import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SectionContainer from "../common/SectionContainer";

function IndustriesPreview() {
  const navigate = useNavigate();
  return (
    <SectionContainer background="#101f2e">

      <div className="industries-preview-v2">

        <div className="industries-header">

          <span className="section-kicker">
            Industries We Serve
          </span>

          <h2>
            Deep Industry Expertise.
            <br />
            Tailored Growth Strategies.
          </h2>

          <p>
            Every industry faces unique growth
            challenges. We combine strategy,
            marketing and technology to help
            organizations create sustainable
            competitive advantages.
          </p>

        </div>
        <div className="industries-footer">

          <button
            className="industries-link-button"
            onClick={() => navigate("/industries")}
          >
            View All Industries
            <ArrowRight size={18} />
          </button>

        </div>

      </div>

    </SectionContainer>
  );
}

export default IndustriesPreview;